import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { TslMultiSelectSettings } from '@tesla/ng-tds';
import { AppSettings } from 'src/app/app.settings';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { PEAssignment } from 'src/app/models/pe-assignment';
import { SioCode } from 'src/app/models/siocode';
import { DataService } from 'src/app/services/data.service';
import { FormService } from 'src/app/services/form';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';

@Component({
  selector: 'app-assign-new-pe',
  templateUrl: './assign-new-pe.component.html',
  styleUrls: ['./assign-new-pe.component.scss']
})
export class AssignNewPeComponent implements OnInit {
  unassignedPeList: any;
  assignnewPEInfoForm: FormGroup;
  public formErrors;
  @ViewChild('PEAutoComplete') PEAutoComplete: TeslaAutocompleteComponent;
  @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;
  autoCompletePEURL: string;
  partSystemList: PartSystemDTO[];
  sioCodeList: SioCode[];
  searchSupplierURL: string;
  peAssignmentDTOList: PEAssignment[] = [];
  SioCodeSettings: TslMultiSelectSettings = {
    enableSearchFilter: true,
    noDataLabel: 'Search For Siocode',
    labelKey: 'Description',
    primaryKey: 'Id'
  }

  constructor(private dialogRef: MatDialogRef<AssignNewPeComponent>,
    @Inject(MAT_DIALOG_DATA) public AssignNewPackageEngineerInfo: any,

    private fb: FormBuilder,
    private formService: FormService,
    private dataService: DataService,
    private toastService: ToastService,
    private localstorageService: LocalstorageService,
    private appSettings: AppSettings,) {

      this.appSettings = appSettings;
      this.autoCompletePEURL = this.appSettings.Packaging2APIUrl + '/peassignment/pe/all';
      this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';
      this.unassignedPeList = AssignNewPackageEngineerInfo;
     }

  ngOnInit() {
    this.assignnewPEInfoForm = this.fb.group({
      PEId: null,
      SupplierCode: null,
      SioCodeId: null,
      PartNumber: null
    });

    this.formErrors = {
      PEId: '',
      SupplierCode: '',
      SioCodeId: '',
      PartNumber: ''
    };

    this.getSioCodes();
  }

  onEmptyPE(eventObj: any): void {
    this.PEAutoComplete.list = [];
  }

  onEmptySupplierCode(eventObj: any): void {
      this.SupplierAutoComplete.list = [];
  }

  getSupplierCode() {
    return this.assignnewPEInfoForm.controls['SupplierCode'].value;
  }

  getSioCodes() {        
    this.dataService.getSioCodes().subscribe((response: any) => {
      if (response != null && response.Success) {
        this.sioCodeList = response.Data;
      }
  });
  }

  //tms-34809 extract siocode ids as a list as tsl-multiselect always returns object  
  getSioCode() {
    var siocode = this.assignnewPEInfoForm.controls['SioCodeId'].value;
    if (siocode != null) {
      const listofsiocodes = siocode.map(({ Id }) => Id);
      return listofsiocodes;
    }
    return siocode;
  }

  //tms-26081 Add new package engineer assignment
  newPEAssignment(){

    this.createRequestModel();
      this.dataService
        .addPEAssignment(this.peAssignmentDTOList)
      .subscribe((response: any) => {
          if (response != null && response.Success) {
              this.dialogRef.close();
              this.toastService.success('New assignment added');
          }
          else {
            this.toastService.error(
                'Assignment request cancelled'
            );
        }
      });
  }

  //tms-33944 siocode will have multi-select functionality 
  SioCodeChanged(siocode: SioCode[]) {
  }


  //tms-33944 create request model to add new assignments. Need to create a list of dto when multiple sio code is selected with same combination of (PE + ST + PS)
  createRequestModel() {
    const sioCode = this.getSioCode();
    const peAssignmentDTO = new PEAssignment();
    peAssignmentDTO.Id = this.unassignedPeList.Id;
    peAssignmentDTO.SourceTypeId = this.unassignedPeList.SourceTypeId;
    peAssignmentDTO.PartCategoryId = this.unassignedPeList.PartCategoryId;
    peAssignmentDTO.EngineerUserId = this.assignnewPEInfoForm.controls['PEId'].value;
    peAssignmentDTO.SupplierCode = this.assignnewPEInfoForm.controls['SupplierCode'].value == null ? null : this.assignnewPEInfoForm.controls['SupplierCode'].value;
    peAssignmentDTO.PartNumber = this.assignnewPEInfoForm.controls['PartNumber'].value == null ? null : this.assignnewPEInfoForm.controls['PartNumber'].value;

    if (sioCode) {
      sioCode.forEach(element => {
        const dto = Object.assign(new PEAssignment(), peAssignmentDTO);
        dto.SioCodeId = element;
        this.peAssignmentDTOList.push(dto);
      });
    } else {
      this.peAssignmentDTOList.push(peAssignmentDTO);
    }
  }


  onSioCodeSearch(val) {
    if (!val || val.length <= 3) {
      this.getSioCodes();
      return;
    }
    else {
      this.sioCodeList = this.sioCodeList.filter(item => item.Description.toLowerCase().startsWith(val.toLowerCase()));
    }
  }


}
